import React from "react";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { IsAlert } from "../component/atoms/IsAlert";
import { fetchApi } from "../helper/api";
const LupaPassword = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    amount: "",
    password: "",
    email: "",
    weight: "",
    weightRange: "",
    showPassword: false,
    errorMessage: [],
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleLogin = async () => {
    var req = await fetchApi("api/User/forgotPass", "POST", false, {
      email: values.email,
    });
    var status = req.status;
    var res = await req.json();
    if (status === 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          navigate("/waiting-confirmation-forgot-password");
        }
      });
    } else {
      setValues({
        ...values,
        errorMessage: res.errors.email,
      });
    }
  };
  return (
    <div className="bg_login row align-items-center m-0 justify-content-center">
      <div className="wrap_login col-lg-3 col-11 shadow p-4 bg-white rounded">
        <div className="row justify-content-center mb-4">
          <div className="logo_login col-6">
            <img alt="" className="w-100" src="/img/masjid.png" />
          </div>
        </div>
        <h1 className="mb-0">Lupa Password</h1>
        <div>
          {values.errorMessage &&
            values.errorMessage.map((e, i) => {
              return <p className="text-danger">{e}</p>;
            })}
        </div>
        <div className="py-2">
          <TextField
            onChange={(e) =>
              setValues({
                ...values,
                email: e.target.value,
              })
            }
            value={values.email}
            className="w-100"
            label="Username / Email"
            variant="standard"
            autoComplete="off"
          />
        </div>
        <div className="py-2 mt-2">
          <Button
            className="w-100"
            variant="contained"
            color="success"
            onClick={handleLogin}
          >
            <i className="las la-sign-in-alt mr-2"></i>
            Submit
          </Button>
        </div>
        <p className="text-center mt-3">
          Sudah punya akun?{" "}
          <Link to="/login" className="text-success">
            Login
          </Link>{" "}
          disini
        </p>
      </div>
    </div>
  );
};
export default LupaPassword;
